

// Navbar.jsx - Corrected Version
import React, { useEffect, useRef, useState } from "react";
import { Link, NavLink } from "react-router-dom";

import Services from "./Services";
import Industries from "./Industries";
import Insights from "./Insights";
import StaffAugmentation from "./StaffAugmentation";
import InforNavbar from "./InforNavbar";
import Solutions from "./Solutions";
import kapilTech from '../../../Assets/Logo/KapilTechnologiesLogo.png'
import KcsTech from '../../../Assets/Logo/Kapil_Tech.png'
import { servicesLinks, industriesLinks, insightsLinks } from '../../../utils/navbarservices'

import { IoMenu } from "react-icons/io5";
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";

export const DropdownIcon = ({ isOpen }) =>
  isOpen ? (
    <IoIosArrowUp className="text-lg transition-transform duration-300 ease-in-out" />
  ) : (
    <IoIosArrowDown className="text-lg transition-transform duration-300 ease-in-out" />
  );

const Navbar = ({ linkClicked }) => {
  const MenuIcon = ({ open }) =>
    open ? (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth="2"
        stroke="currentColor"
        className="w-6 h-6 transition-transform duration-300 ease-in-out"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M6 18L18 6M6 6l12 12"
        />
      </svg>
    ) : (
      <IoMenu className="text-2xl" />
    );

  const [open, setOpen] = useState(false);
  const [active, setActive] = useState("");
  const [smallScreenActive, setSmallScreenActive] = useState("");
  const [smallScreenSubactive, setSmallScreenSubActive] = useState("");

  const servicesPopupRef = useRef(null);
  const servicesContainerRef = useRef(null);
  const InforPopupRef = useRef(null);
  const InforContainerRef = useRef(null);
  const industriesPopupRef = useRef(null);
  const industriesContainerRef = useRef(null);
  const insightsPopupRef = useRef(null);
  const insightsContainerRef = useRef(null);
  const SolutionsPopupRef = useRef(null);
  const SolutionsContainerRef = useRef(null);
  const StaffAugPopupRef = useRef(null);
  const StaffAugContainerRef = useRef(null);
  const hoverCloseTimeoutRef = useRef(null);

  const ActiveRef = useRef(active);
  const { enterprise_technologies, Products } = servicesLinks;

  useEffect(() => {
    ActiveRef.current = active;
  }, [active]);

  const handleClickOutside = (event) => {
    const popupRefs = {
      infor: { popup: InforPopupRef, container: InforContainerRef },
      services: { popup: servicesPopupRef, container: servicesContainerRef },
      industries: { popup: industriesPopupRef, container: industriesContainerRef },
      insights: { popup: insightsPopupRef, container: insightsContainerRef },
      Solutions: { popup: SolutionsPopupRef, container: SolutionsContainerRef },
      staffAugmentation: { popup: StaffAugPopupRef, container: StaffAugContainerRef }
    };

    const currentRefs = popupRefs[ActiveRef.current];
    if (currentRefs) {
      if (
        currentRefs.popup.current &&
        !currentRefs.popup.current.contains(event.target) &&
        currentRefs.container.current &&
        !currentRefs.container.current.contains(event.target)
      ) {
        setActive("");
      }
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      if (hoverCloseTimeoutRef.current) {
        clearTimeout(hoverCloseTimeoutRef.current);
      }
    };
  }, []);

  // Nagarro-inspired styling
  const navItemClasses = "relative group py-6 px-4 text-[#333333] font-medium transition-all duration-300 ease-out cursor-pointer";
  const hoverEffectClasses = "absolute bottom-0 left-0 w-0 h-0.5 bg-[#E4002B] transition-all duration-300 ease-out group-hover:w-full";
  const textHoverClasses = "group-hover:text-[#E4002B] transition-colors duration-300 ease-out relative z-10";

  const handleNavClick = (navType) => {
    if (active !== navType) {
      setActive(navType);
    } else {
      setActive("");
    }
    if (linkClicked) linkClicked();
  };

  const handleMouseEnter = (navType) => {
    if (hoverCloseTimeoutRef.current) {
      clearTimeout(hoverCloseTimeoutRef.current);
      hoverCloseTimeoutRef.current = null;
    }
    setActive(navType);
  };

  const handleMouseLeave = () => {
    if (hoverCloseTimeoutRef.current) {
      clearTimeout(hoverCloseTimeoutRef.current);
    }

    hoverCloseTimeoutRef.current = setTimeout(() => {
      setActive("");
      hoverCloseTimeoutRef.current = null;
    }, 150);
  };

  const handleMobileNavClick = (navType) => {
    if (smallScreenActive !== navType) {
      setSmallScreenActive(navType);
    } else {
      setSmallScreenActive("");
    }
    setSmallScreenSubActive("");
  };

  return (
    <nav className="bg-white shadow-sm xl:sticky xl:top-0 xl:z-50 border-b border-[#F0F0F0] w-full">
      {/* Desktop Top Utility Bar */}
      <div className="bg-[#001534] text-white py-2 px-8 xl:flex hidden border-b border-[#002b5c] w-full">
        <div className="max-w-7xl mx-auto w-full flex items-center justify-between lg:px-8 text-sm">
          <div className="flex items-center whitespace-nowrap">
            <a
              href="tel:+918889992746"
              className="hover:text-[#bce3ff] transition-colors duration-300"
            >
              India: +91 88899 92746
            </a>
            <span className="mx-3 h-3 w-px bg-white/20" aria-hidden="true"></span>
            <a
              href="tel:+6285218084208"
              className="hover:text-[#bce3ff] transition-colors duration-300"
            >
              Indonesia: +62 852-1808-4208
            </a>
            <span className="mx-3 h-3 w-px bg-white/20" aria-hidden="true"></span>
            <a
              href="tel:+19042570189"
              className="hover:text-[#bce3ff] transition-colors duration-300"
            >
              USA: +1 (904) 257-0189
            </a>
          </div>

          <div className="flex items-center gap-4">
            <a href="mailto:info@kapiltech.com" className="hover:text-[#bce3ff] transition-colors duration-300">
              info@kapiltech.com
            </a>
            <div className="h-3 w-px bg-white/20" aria-hidden="true"></div>
            <div className="flex items-center gap-4">
              <span>Follow us:</span>
              <div className="flex items-center gap-3">
              <a
                href="https://www.linkedin.com/company/kapiltech"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:scale-110 transition-transform duration-200"
                aria-label="LinkedIn"
              >
                <svg viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="14" height="14">
                  <path d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z" />
                </svg>
              </a>
              <a
                href="https://www.instagram.com/kapil_tech_it_staffing/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:scale-110 transition-transform duration-200"
                aria-label="Instagram"
              >
                <svg viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="14" height="14">
                  <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" />
                </svg>
              </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex items-center font-medium justify-between xl:h-24 lg:px-8 max-w-7xl mx-auto w-full">
        {/* Logo Section */}
        <div className="z-50 p-4 xl:w-auto w-full flex justify-between items-center">
          <Link
            to="/"
            className="transition-transform duration-200 hover:scale-105 flex items-center gap-2 sm:gap-3"
            onClick={() => linkClicked && linkClicked()}
          >
            <img
              src={KcsTech}
              alt="Kapil_Technologies_logo"
              className="xl:cursor-pointer h-12 sm:h-14 xl:h-16 py-1 shrink-0"
            />
            <span className="h-10 sm:h-12 w-[1px] bg-[#D6DDE8]" aria-hidden="true"></span>
            <span className="flex flex-col leading-tight">
              <span className="whitespace-nowrap text-[10px] sm:text-[11px] xl:text-[16px] font-bold text-[#001534] uppercase tracking-wide">
                Global Tech Staffing Company
              </span>
              <span className="whitespace-nowrap text-[8px] sm:text-[9px] xl:text-[14px] font-bold text-[#4B5563] tracking-wide">
                Singapore | Indonesia | India | USA
              </span>
            </span>
          </Link>

          <div
            className="xl:hidden p-2 rounded-lg hover:bg-[#F8F8F8] transition-colors duration-200"
            onClick={() => setOpen(!open)}
          >
            <MenuIcon open={open} />
          </div>
        </div>

        {/* Desktop Navigation */}
        <ul className="xl:flex hidden items-center gap-1 relative mx-auto">
          <li className={navItemClasses}>
            <NavLink
              to="/"
              className={`${textHoverClasses} flex items-center relative text-[#333333] font-normal`}
              onClick={() => handleNavClick("home")}
            >
              <span>Home</span>
              <span className={hoverEffectClasses}></span>
            </NavLink>
          </li>

          {/* Employer */}
          {/* <li className={navItemClasses}>
            <NavLink
              to="/employer"
              className={`${textHoverClasses} flex items-center relative text-[#333333] font-normal`}
              onClick={() => handleNavClick("employer")}
            >
              Employer
              <span className={hoverEffectClasses}></span>
            </NavLink>
          </li> */}

          {/* Services Dropdown */}
          <li
            className="relative"
            ref={StaffAugContainerRef}
            onMouseEnter={() => handleMouseEnter("staffAugmentation")}
            onMouseLeave={handleMouseLeave}
          >
            <div className={navItemClasses}>
              <span
                className={`${textHoverClasses} ${active === "staffAugmentation" ? "text-[#E4002B]" : ""
                  } flex items-center gap-1 relative text-[#333333] font-normal`}
              >
                Services
                <DropdownIcon isOpen={active === "staffAugmentation"} />
                <span className={`${hoverEffectClasses} ${active === "staffAugmentation" ? "w-full bg-[#E4002B]" : ""
                  }`}></span>
              </span>
            </div>

            {active === "staffAugmentation" && (
              <div className="absolute top-full left-1/2 z-50 max-w-[calc(100vw-2rem)] -translate-x-1/2 pt-1" ref={StaffAugPopupRef}>
                <StaffAugmentation
                  servicesLinks={servicesLinks.staffAugLinks} // This should be correct
                  active={active}
                  setActive={setActive}
                  setSmallScreenActive={setSmallScreenActive}
                  setOpen={setOpen}
                  linkClicked={linkClicked}
                />
              </div>
            )}
          </li>

          {/* Services Dropdown Container */}
          {/* <li
            className="relative"
            ref={servicesContainerRef}
            onMouseEnter={() => handleMouseEnter("services")}
            onMouseLeave={handleMouseLeave}
          >
            <div className={navItemClasses}>
              <span
                className={`${textHoverClasses} ${
                  active === "services" ? "text-[#E4002B]" : ""
                } flex items-center gap-1 relative text-[#333333] font-normal`}
              >
                Consulting Services
                <DropdownIcon isOpen={active === "services"} />
                <span className={`${hoverEffectClasses} ${
                  active === "services" ? "w-full bg-[#E4002B]" : ""
                }`}></span>
              </span>
            </div>
            
            {active === "services" && (
              <div className="absolute top-full left-0 z-50 mt-1" ref={servicesPopupRef}>
                <Services
                  servicesLinks={enterprise_technologies?.links}
                  active={active}
                  setActive={setActive}
                  setSmallScreenActive={setSmallScreenActive}
                  setOpen={setOpen}
                  linkClicked={linkClicked}
                />
              </div>
            )}
          </li> */}

          {/* Products */}
          {/* <li
            className="relative"
            ref={SolutionsContainerRef}
            onMouseEnter={() => handleMouseEnter("Solutions")}
            onMouseLeave={handleMouseLeave}
          >
            <div className={navItemClasses}>
              <span
                className={`${textHoverClasses} ${
                  active === "Solutions" ? "text-[#E4002B]" : ""
                } flex items-center gap-1 relative text-[#333333] font-normal`}
              >
                Our Solutions
                <DropdownIcon isOpen={active === "Solutions"} />
                <span className={`${hoverEffectClasses} ${
                  active === "Solutions" ? "w-full bg-[#E4002B]" : ""
                }`}></span>
              </span>
            </div>
            {active === "Solutions" && (
              <div className="absolute top-full left-0 z-50 mt-1" ref={SolutionsPopupRef}>
                <Solutions
                  SolutionsLinks={Products}
                  active={active}
                  setActive={setActive}
                  setSmallScreenActive={setSmallScreenActive}
                  setOpen={setOpen}
                  linkClicked={linkClicked}
                />
              </div>
            )}
          </li> */}

          {/* Industries Dropdown Container */}
          {/* <li
            className="relative"
            ref={industriesContainerRef}
            onMouseEnter={() => handleMouseEnter("industries")}
            onMouseLeave={handleMouseLeave}
          >
            <div className={navItemClasses}>
              <span
                className={`${textHoverClasses} ${
                  active === "industries" ? "text-[#E4002B]" : ""
                } flex items-center gap-1 relative text-[#333333] font-normal`}
              >
                Industries
                <DropdownIcon isOpen={active === "industries"} />
                <span className={`${hoverEffectClasses} ${
                  active === "industries" ? "w-full bg-[#E4002B]" : ""
                }`}></span>
              </span>
            </div>
            {active === "industries" && (
              <div className="absolute top-full left-0 z-50 mt-1" ref={industriesPopupRef}>
                <Industries
                  industriesLinks={industriesLinks}
                  active={active}
                  setActive={setActive}
                  setSmallScreenActive={setSmallScreenActive}
                  setOpen={setOpen}
                  linkClicked={linkClicked}
                />
              </div>
            )}
          </li> */}

          {/* Insights Dropdown Container */}
          <li
            className="relative"
            ref={insightsContainerRef}
            onMouseEnter={() => handleMouseEnter("insights")}
            onMouseLeave={handleMouseLeave}
          >
            <div className={navItemClasses}>
              <span
                className={`${textHoverClasses} ${active === "insights" ? "text-[#E4002B]" : ""
                  } flex items-center gap-1 relative text-[#333333] font-normal`}
              >
                Insights
                <DropdownIcon isOpen={active === "insights"} />
                <span className={`${hoverEffectClasses} ${active === "insights" ? "w-full bg-[#E4002B]" : ""
                  }`}></span>
              </span>
            </div>
            {active === "insights" && (
              <div className="absolute top-full left-0 z-50 mt-1" ref={insightsPopupRef}>
                <Insights
                  insightsLinks={insightsLinks}
                  setActive={setActive}
                  linkClicked={linkClicked}
                />
              </div>
            )}
          </li>


          {/* Careers Dropdown */}
          <li
            className="relative"
            onMouseEnter={() => handleMouseEnter("career")}
            onMouseLeave={handleMouseLeave}
          >
            <div className={navItemClasses}>
              <button
                type="button"
                className={`${textHoverClasses} ${active === "career" ? "text-[#E4002B]" : ""
                  } flex items-center gap-1 relative text-[#333333] font-normal`}
                onClick={() => handleNavClick("career")}
                aria-expanded={active === "career"}
                aria-haspopup="true"
              >
                Careers
                <DropdownIcon isOpen={active === "career"} />
                <span className={`${hoverEffectClasses} ${active === "career" ? "w-full bg-[#E4002B]" : ""
                  }`}></span>
              </button>
            </div>

            {active === "career" && (
              <div className="absolute left-1/2 top-full z-50 min-w-72 -translate-x-1/2 whitespace-nowrap rounded-lg border border-[#E5E7EB] bg-white p-2 pt-[calc(0.5rem+4px)] shadow-lg">
                <Link
                  to="/careers/life-at-kapiltech"
                  className="block rounded-md px-4 py-3 text-sm text-[#333333] transition-colors hover:bg-[#F8F8F8] hover:text-[#E4002B]"
                  onClick={() => {
                    setActive("");
                    if (linkClicked) linkClicked();
                  }}
                >
                  Life at KapilTech
                </Link>
                <Link
                  to="/careers/open-positions"
                  className="block rounded-md px-4 py-3 text-sm text-[#333333] transition-colors hover:bg-[#F8F8F8] hover:text-[#E4002B]"
                  onClick={() => {
                    setActive("");
                    if (linkClicked) linkClicked();
                  }}
                >
                  Open Positions
                </Link>
                <Link
                  to="/careers/job-connecter-bootcamp"
                  className="block rounded-md px-4 py-3 text-sm text-[#333333] transition-colors hover:bg-[#F8F8F8] hover:text-[#E4002B]"
                  onClick={() => {
                    setActive("");
                    if (linkClicked) linkClicked();
                  }}
                >
                  Job Connecter Bootcamp
                </Link>
                <Link
                  to="/careers/skill-accelerator-bootcamp"
                  className="block rounded-md px-4 py-3 text-sm text-[#333333] transition-colors hover:bg-[#F8F8F8] hover:text-[#E4002B]"
                  onClick={() => {
                    setActive("");
                    if (linkClicked) linkClicked();
                  }}
                >
                  Skill Accelerator Bootcamp
                </Link>
                {/* <Link
                  to="/careers/bde-team"
                  className="block rounded-md px-4 py-3 text-sm text-[#333333] transition-colors hover:bg-[#F8F8F8] hover:text-[#E4002B]"
                  onClick={() => {
                    setActive("");
                    if (linkClicked) linkClicked();
                  }}
                >
                  Business Development Team
                </Link> */}
              </div>
            )}
          </li>


          {/* Contact */}
          <li className={navItemClasses}>
            <NavLink
              to="/contact"
              className={`${textHoverClasses} flex items-center relative text-[#333333] font-normal`}
              onClick={() => handleNavClick("contact")}
            >
              Contact
              <span className={hoverEffectClasses}></span>
            </NavLink>
          </li>
        </ul>

        {/* Mobile Navigation */}
        <ul
          className={`xl:hidden bg-white fixed text-[#333333] w-full h-screen top-0 py-24 pl-4 z-40 transition-all duration-500 ease-in-out transform ${open ? "left-0 opacity-100" : "left-[-100%] opacity-0"
            } shadow-xl overflow-y-auto`}
        >
          <li className="border-b border-[#F0F0F0] py-1" onClick={() => setOpen(false)}>
            <Link
              to="/"
              className="py-4 px-4 inline-block text-base text-[#333333] hover:text-[#E4002B] transition-colors duration-200 font-medium"
            >
              Home
            </Link>
          </li>

          {/* Employer */}
          {/* <li className="py-1" onClick={() => setOpen(false)}>
            <Link
              to="/employer"
              className="py-4 px-4 inline-block text-base text-[#333333] hover:text-[#E4002B] transition-colors duration-200 font-medium"
            >
              Employer
            </Link>
          </li> */}

          {/* Staff Augmentation Mobile */}
          <li className="border-b border-[#F0F0F0] py-1">
            <span
              className="py-4 px-4 text-base text-[#333333] xl:hidden flex justify-between items-center cursor-pointer hover:text-[#E4002B] transition-colors duration-200 font-medium"
              onClick={() => handleMobileNavClick("staffAugmentation")}
            >
              Services
              <DropdownIcon isOpen={smallScreenActive === "staffAugmentation"} />
            </span>
            <div className={`xl:hidden overflow-hidden transition-all duration-300 ${smallScreenActive === "staffAugmentation" ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
              }`}>
              {smallScreenActive === "staffAugmentation" && (
                <StaffAugmentation
                  servicesLinks={servicesLinks?.staffAugLinks}
                  smallScreenActive={smallScreenActive}
                  setActive={setActive}
                  setSmallScreenSubActive={setSmallScreenSubActive}
                  setSmallScreenActive={setSmallScreenActive}
                  setOpen={setOpen}
                  linkClicked={linkClicked}
                />
              )}
            </div>
          </li>

          {/* Infor section */}
          {/* <li className="border-b border-[#F0F0F0] py-1">
            <span
              className="py-4 px-4 text-base text-[#333333] xl:hidden flex justify-between items-center cursor-pointer hover:text-[#E4002B] transition-colors duration-200 font-medium"
              onClick={() => handleMobileNavClick("infor")}
            >
              Infor
              <DropdownIcon isOpen={smallScreenActive === "infor"} />
            </span>
            <div className={`xl:hidden overflow-hidden transition-all duration-300 ${
              smallScreenActive === "infor" ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
            }`}>
              {smallScreenActive === "infor" && (
                <InforNavbar
                  servicesLinks={enterprise_technologies}
                  smallScreenSubactive={smallScreenSubactive}
                  setSmallScreenSubActive={setSmallScreenSubActive}
                  setSmallScreenActive={setSmallScreenActive}
                  setOpen={setOpen}
                  linkClicked={linkClicked}
                />
              )}
            </div>
          </li> */}

          {/* <li className="border-b border-[#F0F0F0] py-1">
            <span
              className="py-4 px-4 text-base text-[#333333] xl:hidden flex justify-between items-center cursor-pointer hover:text-[#E4002B] transition-colors duration-200 font-medium"
              onClick={() => handleMobileNavClick("Solutions")}
            >
              Our Solutions
              <DropdownIcon isOpen={smallScreenActive === "Solutions"} />
            </span>
            <div className={`xl:hidden overflow-hidden transition-all duration-300 ${
              smallScreenActive === "Solutions" ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
            }`}>
              {smallScreenActive === "Solutions" && (
                <Solutions
                  SolutionsLinks={Products}
                  smallScreenActive={smallScreenActive}
                  setActive={setActive}
                  setSmallScreenSubActive={setSmallScreenSubActive}
                  setSmallScreenActive={setSmallScreenActive}
                  setOpen={setOpen}
                  linkClicked={linkClicked}
                />
              )}
            </div>
          </li> */}

          {/* <li className="border-b border-[#F0F0F0] py-1">
            <span
              className="py-4 px-4 text-base text-[#333333] xl:hidden flex justify-between items-center cursor-pointer hover:text-[#E4002B] transition-colors duration-200 font-medium"
              onClick={() => handleMobileNavClick("industries")}
            >
              Industries
              <DropdownIcon isOpen={smallScreenActive === "industries"} />
            </span>
            <div className={`xl:hidden overflow-hidden transition-all duration-300 ${
              smallScreenActive === "industries" ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
            }`}>
              {smallScreenActive === "industries" && (
                <Industries
                  industriesLinks={industriesLinks}
                  smallScreenActive={smallScreenActive}
                  setSmallScreenSubActive={setSmallScreenSubActive}
                  setSmallScreenActive={setSmallScreenActive}
                  setOpen={setOpen}
                  linkClicked={linkClicked}
                />
              )}
            </div>
          </li> */}

          <li className="border-b border-[#F0F0F0] py-1">
            <span
              className="py-4 px-4 text-base text-[#333333] xl:hidden flex justify-between items-center cursor-pointer hover:text-[#E4002B] transition-colors duration-200 font-medium"
              onClick={() => handleMobileNavClick("insights")}
            >
              Insights
              <DropdownIcon isOpen={smallScreenActive === "insights"} />
            </span>
            <div className={`xl:hidden overflow-hidden transition-all duration-300 ${smallScreenActive === "insights" ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
              }`}>
              {smallScreenActive === "insights" && (
                <Insights
                  insightsLinks={insightsLinks}
                  smallScreenActive={smallScreenActive}
                  setActive={setActive}
                  setSmallScreenSubActive={setSmallScreenSubActive}
                  setSmallScreenActive={setSmallScreenActive}
                  setOpen={setOpen}
                />
              )}
            </div>
          </li>

          {/* Careers Mobile Dropdown */}
          <li className="border-b border-[#F0F0F0] py-1">
            <button
              type="button"
              className="flex w-full items-center justify-between px-4 py-4 text-left text-base font-medium text-[#333333] transition-colors duration-200 hover:text-[#E4002B]"
              onClick={() => handleMobileNavClick("career")}
              aria-expanded={smallScreenActive === "career"}
            >
              Careers
              <DropdownIcon isOpen={smallScreenActive === "career"} />
            </button>
            <div
              className={`overflow-hidden transition-all duration-300 ${smallScreenActive === "career" ? "max-h-64 opacity-100" : "max-h-0 opacity-0"
                }`}
            >
              {smallScreenActive === "career" && (
                <div className="flex flex-col gap-1 px-8 pb-3">
                  <Link
                    to="/careers/life-at-kapiltech"
                    className="py-2 text-sm text-[#333333] hover:text-[#E4002B]"
                    onClick={() => setOpen(false)}
                  >
                    Life at KapilTech
                  </Link>
                  <Link
                    to="/careers/open-positions"
                    className="py-2 text-sm text-[#333333] hover:text-[#E4002B]"
                    onClick={() => setOpen(false)}
                  >
                    Open Positions
                  </Link>
                  <Link
                    to="/careers/job-connecter-bootcamp"
                    className="py-2 text-sm text-[#333333] hover:text-[#E4002B]"
                    onClick={() => setOpen(false)}
                  >
                    Job Connecter Bootcamp
                  </Link>
                  <Link
                    to="/careers/skill-accelerator-bootcamp"
                    className="py-2 text-sm text-[#333333] hover:text-[#E4002B]"
                    onClick={() => setOpen(false)}
                  >
                    Skill Accelerator Bootcamp
                  </Link>
                  <Link
                    to="/careers/bde-team"
                    className="py-2 text-sm text-[#333333] hover:text-[#E4002B]"
                    onClick={() => setOpen(false)}
                  >
                    Business Development Team
                  </Link>
                </div>
              )}
            </div>
          </li>

          <li className="py-1 border-b border-[#F0F0F0]" onClick={() => setOpen(false)}>
            <Link
              to="/contact"
              className="py-4 px-4 inline-block text-base text-[#333333] hover:text-[#E4002B] transition-colors duration-200 font-medium"
            >
              Contact
            </Link>
          </li>

          {/* Mobile Socials & Email */}
          <li className="mt-8 px-4 flex flex-col gap-4">
            <div>
              <span className="text-xs font-semibold text-gray-400 uppercase tracking-widest block mb-1">Mail Us</span>
              <a href="mailto:info@kapiltech.com" className="text-[#333333] hover:text-[#001534] font-medium text-sm transition-colors duration-200">
                info@kapiltech.com
              </a>
            </div>
            <div>
              <span className="text-xs font-semibold text-gray-400 uppercase tracking-widest block mb-2">Follow Us</span>
              <div className="flex gap-4">
                <a
                  href="https://www.linkedin.com/company/kapiltech"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-2 bg-gray-100 rounded-full text-[#333333] hover:bg-[#001534] hover:text-white transition-all duration-200"
                  aria-label="LinkedIn"
                >
                  <svg viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="16" height="16">
                    <path d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z" />
                  </svg>
                </a>
                <a
                  href="https://www.instagram.com/kapil_tech_it_staffing/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-2 bg-gray-100 rounded-full text-[#333333] hover:bg-[#001534] hover:text-white transition-all duration-200"
                  aria-label="Instagram"
                >
                  <svg viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="16" height="16">
                    <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" />
                  </svg>
                </a>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
